export const nullNoop = () => null;
export const futureNoop = async () => {
  return null;
};

export default () => {};
